import { URL } from "Auth/config";

export const API_ENDPOINTS = {
  ESTRATIFICADO: {
    LISTAR_MUNICIPIOS: `${URL}estratificado/listar-municipios`,
    BUSCAR_POR_MUNICIPIO: `${URL}/estratificado/estratificado-por-municipio`,
    LISTAR_POR_COMUNIDAD: `${URL}estratificado/listar-por-comunidad`,
    LISTAR_MESES: `${URL}estratificado/listar-meses`,
  },
  
};